module.exports = __webpack_public_path__ + "img/wonderfulGod.04d94c38.png";